import { gql } from '@apollo/client';

export const USERS = gql`
  query User {
    users {
      id
      isVerified
      name
      email
      roles
      contractor {
        id
        name
        phone
        email
        description
        availableArea {
          states
          counties
        }
        userId
      }
    }
  }
`;

export const USER = gql`
  query User($id: ID!) {
    user(id: $id) {
      id
      isVerified
      name
      email
      roles
      createdAt
      contractor {
        id
        userId
        name
        phone
        email
        description
        availableArea {
          states
          counties
        }
        createdAt
        updatedAt
      }
    }
  }
`;
